module.exports = __webpack_public_path__ + "static/img/h5-5.0b6e56c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h5-5.png
// module id = wgzi
// module chunks = 1